import { watch, computed, reactive, ref } from 'vue'
import { NuxeoOrdersRequest } from '@/contracts/api/RequestContracts'
import { NuxeoPageProviderResponse, HMCTSOrderState } from '@/contracts/api/ResponseContracts'
import { nuxeoOrders } from '@/composables/nuxeo'
import { FieldsStructure } from '@/contracts/forms/FieldContracts'
import { pageprovider } from '@/composables/pageprovider'
import { useStore } from 'vuex'

// Prepare orders methods and data:
export function orders(pageSize = 10)
{
    // Use vuex:
    const store = useStore()
    // Get user data:
    const authenticatedUser = computed(() =>
    {
        return store.getters['auth/getUser']
    })
    // Prepare for page provider:
    const {
        data,
        numberOfPaginationPages,
        currentPageIndex,
        sortDirection,
        sortColumn,
        prevPage,
        nextPage,
        goToPage
    } = pageprovider()
    // Hold reactive form data:
    const filterFormData = reactive({} as FieldsStructure)
    // Set order params for request:
    const orderParams = computed(() =>
    {
        return {
            currentPageIndex: currentPageIndex.value,
            customerID: authenticatedUser.value.id,
            sortBy: (sortColumn.value === 'none' ? '' : sortColumn.value),
            sortOrder: (sortDirection.value === 'ascending' ? 'ASC' : 'DESC'),
            pageSize: pageSize,
            orderNumber: (filterFormData.ordernumber !== undefined && typeof filterFormData.ordernumber.value === 'string' ? filterFormData.ordernumber.value.toUpperCase() : ''),
            surname: (filterFormData.surname !== undefined && typeof filterFormData.surname.value === 'string' ? filterFormData.surname.value.toUpperCase() : ''),
            firstnames: (filterFormData.firstnames !== undefined && typeof filterFormData.firstnames.value === 'string' ? filterFormData.firstnames.value.toUpperCase() : '')
        } as NuxeoOrdersRequest
    })
    // Function to set filtering data:
    const setFilterParams = function(filterData: FieldsStructure)
    {
        Object.assign(filterFormData, filterData)
    }
    // Watch to trigger search:
    watch(filterFormData, function()
    {
        currentPageIndex.value = 0
        getOrders()
    })
    // Watch to trigger search:
    watch(currentPageIndex, function()
    {
        getOrders()
    })
    watch(authenticatedUser, function()
    {
        getOrders()
    })
    // Filter order state function:
    const filterOrderState = function(orderStates: Array<HMCTSOrderState>): Array<HMCTSOrderState>
    {
        const orderNumbers: Array<string> = []
        const ordersStatesCopy: Array<HMCTSOrderState> = []
        for(let i = 0; i < orderStates.length; i++)
        {
            if(!orderNumbers.includes(orderStates[i].orderNumber))
            {
                ordersStatesCopy.push(orderStates[i])
                orderNumbers.push(orderStates[i].orderNumber)
            }
        }
        return ordersStatesCopy
    }
    // Sort order state function:
    const compareOrderState = function(a: HMCTSOrderState, b: HMCTSOrderState)
    {
        if(a.orderNumber === b.orderNumber)
        {
            return -1
        }
        if(new Date(a.orderDate).getTime() < new Date(b.orderDate).getTime())
        {
            return 1
        }
        if(new Date(a.orderDate).getTime() > new Date(b.orderDate).getTime())
        {
            return -1
        }
        return 0
    }
    // Get orders:
    const getOrders = function()
    {
        nuxeoOrders(
        authenticatedUser.value.id,
        authenticatedUser.value.password,
        orderParams.value,
        function(response: NuxeoPageProviderResponse)
        {
            // Order by most recent:
            for(let i = 0; i < response.entries.length; i++)
            {
                const orderState = filterOrderState(response.entries[i].properties['hmctsgrant:ordersState'])
                orderState.sort(compareOrderState)
                response.entries[i].properties['hmctsgrant:ordersState'] = orderState
            }
            Object.assign(data, response)
        })
    }

    getOrders()

    return {
        data,
        numberOfPaginationPages,
        currentPageIndex,
        sortDirection,
        sortColumn,
        getOrders,
        prevPage,
        nextPage,
        goToPage,
        setFilterParams
    }
}
